import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/images/logo.png";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navbarRef = useRef(null);
  const menuIconRef = useRef(null);
  const fullPageMenuRef = useRef(null);
  const [navbarHeight, setNavbarHeight] = useState(0);

  useEffect(() => {
    setNavbarHeight(navbarRef.current?.offsetHeight || 0);

    const handleResize = () => {
      setNavbarHeight(navbarRef.current?.offsetHeight || 0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToSection = (section) => {
    const scrollPosition = section.offsetTop - navbarHeight;

    if (Math.abs(scrollPosition - window.scrollY) > 10) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  const handleLinkClick = (e, sectionId) => {
    e.preventDefault();
    const section = document.querySelector(`#${sectionId}`);
    if (section) scrollToSection(section);

    setIsMenuOpen(false);
    if (menuIconRef.current) menuIconRef.current.checked = false;
  };

  const sections = [
    { id: "offerings", text: "OFFERINGS", margin: "5rem" },
    { id: "designs", text: "DESIGNS", margin: "5rem" },
    { id: "aboutus", text: "ABOUT US", margin: "5rem" },
    { id: "referral", text: "REFERRAL", margin: "5rem" },
    { id: "partners", text: "PARTNERS", margin: "5rem" },
    { id: "contact", text: "CONTACT", margin: "5rem" },
  ];

  return (
    <>
      <div className="navbar" ref={navbarRef}>
        {sections.slice(0, 3).map((section) => (
          <a
            key={section.id}
            href={`#${section.id}`}
            className="navbar-link"
            style={{ marginRight: section.margin }}
            onClick={(e) => handleLinkClick(e, section.id)}
          >
            {section.text}
          </a>
        ))}

        <a href="/">
          <img src={logo} alt="BITS nd Space" className="logo" />
        </a>

        {sections.slice(3).map((section) => (
          <a
            key={section.text}
            href={`#${section.id}`}
            className="navbar-link"
            style={{ marginLeft: section.margin }}
            onClick={(e) => handleLinkClick(e, section.id)}
          >
            {section.text}
          </a>
        ))}

        <label className="hamburger">
          <input
            type="checkbox"
            ref={menuIconRef}
            checked={isMenuOpen}
            onChange={() => setIsMenuOpen(!isMenuOpen)}
          />
          <svg viewBox="0 0 32 32">
            <path
              className="line line-top-bottom"
              d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
            />
            <path className="line" d="M7 16 27 16" />
          </svg>
        </label>
      </div>

      <div
        className={`full-page-menu ${isMenuOpen ? "active" : ""}`}
        ref={fullPageMenuRef}
      >
        <ul>
          {sections.map((section) => (
            <li key={section.text}>
              <a
                href={`#${section.id}`}
                onClick={(e) => handleLinkClick(e, section.id)}
              >
                {section.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Navbar;
